import { render, staticRenderFns } from "./app-orderItem.vue?vue&type=template&id=16e030aa"
import script from "./app-orderItem.vue?vue&type=script&lang=js"
export * from "./app-orderItem.vue?vue&type=script&lang=js"
import style0 from "./app-orderItem.vue?vue&type=style&index=0&id=16e030aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports